import { useContext } from 'react';
import { MediaContext } from 'components/mediaQuery';

import Table from './table';
import List from './list';

const Pools = ({ loading, list = [] }) => {
  const { tablet } = useContext(MediaContext);
  const ELem = tablet ? List : Table;

  return (
    <ELem {...{ loading, list }} />
  );
};

export default Pools;
